import Vue from 'vue'
import i18n from '@ms/lang/i18n.js'
import dialogVue from './main.vue'
import themeDialogVue from './themeMain.vue'
import { isVNode } from '../../utils/vnode'

const defaults = {
  title: null,
  message: '',
  showClose: true,
  classNames: [],
  // footer 按钮方向，默认水平
  direction: 'horizontal',
  confirmButtonText: 'OK',
  cancelButtonText: 'CANCEL',
  beforeClose: null,
  showFooter: false,
  dangerouslyUseHTMLString: false,
  distinguishCancelAndClose: false,
  closeOnClickModal: false,
  maxWidth: '',
  moreButtonText: []
}

const VDialogConstructor = Vue.extend(dialogVue)
const VThemeDialogConstructor = Vue.extend(themeDialogVue)

let currentMsg, instance
let msgQueue = []

const defaultCallback = (action) => {
  if (currentMsg) {
    const callback = currentMsg.callback
    if (typeof callback === 'function') {
      if (instance.showInput) {
        callback(instance.inputValue, action)
      } else {
        callback(action)
      }
    }
    if (currentMsg.resolve) {
      if (action.includes('confirm')) {
        if (instance.showInput) {
          currentMsg.resolve({ value: instance.inputValue, action })
        } else {
          currentMsg.resolve(action)
        }
      } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
        currentMsg.reject(action)
      }
    }
  }
}

const initInstance = (isPc, useTheme = false) => {
  instance = useTheme
    ? new VThemeDialogConstructor({
        i18n,
        el: document.createElement('div')
      })
    : new VDialogConstructor({
        i18n,
        el: document.createElement('div')
      })
      
  instance.pc = isPc
  instance.callback = defaultCallback
}

const showNextMsg = (isPc, useTheme = false) => {
  // if (!instance) {
  initInstance(isPc, useTheme)
  // }
  instance.action = ''

  if (!instance.visible || instance.closeTimer) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift()

      const options = currentMsg.options
      for (const prop in options) {
        instance[prop] = options[prop]
      }
      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }

      const oldCb = instance.callback
      instance.callback = (action, instance) => {
        oldCb(action, instance)
        showNextMsg(isPc, useTheme)
      }
      if (isVNode(instance.message)) {
        instance.$slots.default = [instance.message]
        instance.message = null
      } else {
        delete instance.$slots.default
      }
      ;['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach((prop) => {
        if (instance[prop] === undefined) {
          instance[prop] = true
        }
      })
      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visible = true
      })
    }
  }
}

function createDialog(isPc, useTheme = false) {
  const dialog = (options, callback) => {
    if (typeof options === 'string' || isVNode(options)) {
      options = {
        message: options
      }
      if (typeof arguments[1] === 'string') {
        options.title = arguments[1]
      }
    } else if (options.callback && !callback) {
      callback = options.callback
    }

    return new Promise((resolve, reject) => {
      msgQueue.push({
        options: Object.assign({}, defaults, VDialog.defaults, options),
        callback,
        resolve,
        reject
      })

      showNextMsg(isPc, useTheme)
    })
  }
  dialog.setDefaults = (defaults) => {
    VDialog.defaults = defaults
  }
  dialog.close = () => {
    if (instance) {
      instance.doClose()
      instance.visible = false
      msgQueue = []
      currentMsg = null
    }
    if (msgQueue.length) {
      msgQueue.forEach((item) => {
        item.doClose()
      })
    }
  }
  return dialog
}

export const VDialog = createDialog()
export const ThemeVDialog = createDialog(false, true)
export const XDialog = createDialog(true)

export default VDialog
